import { GET_CALENDER } from "../constants/index";

export const calender = (state = { calenderdetails: [] }, action) => {
  switch (action.type) {
    case GET_CALENDER:
      return { ...state, calenderdetails: action.calenderdetails };
    default:
      return state;
  }
};
